<template>
  <div class="ai-quiz-banner__wrapper">
    <img :src="AIQuizBanner" class="banner__image" />
    <div class="banner__text">
      <p class="text-sm font-bold xl:text-base">
        Leave the hard work to the new
      </p>
      <div class="banner__text--under">
        <p class="text-lg font-bold xl:text-xl">
          ✨ AI Quiz Generator
        </p>
        <aha-icon
          name="arrow-tail"
          viewBox="0 0 18 19"
          width="20"
          height="21"
          class="banner__icon"
        />
      </div>
      <aha-button
        variant="base"
        @click="handleCreateNewPresentation()"
        class="banner__button"
      >
        Try out now
      </aha-button>
    </div>
    <aha-icon
      name="close"
      class="text-base-0 banner__close"
      @click="handleClose"
    />
  </div>
</template>

<script>
import AIQuizBanner from '@/assets/images/onboarding/AIQuizBanner.png'
import utils from '@/util'
import CreateNewPresentationMixin from '@/mixins/presentation/CreateNewPresentationMixin'

import gaCategories from '@/constant/gaCategories'

export default {
  mixins: [CreateNewPresentationMixin],
  data() {
    return {
      AIQuizBanner,
    }
  },
  created() {
    utils.preloadImage({ url: this.AIQuizBanner })
  },
  methods: {
    handleCreateNewPresentation() {
      this.createNewPresentation('AI banner') // CreateNewPresentationMixin
    },
    handleClose() {
      this.$emit('close')
      utils.gaTrackEvent(
        gaCategories.PRESENTATION_LIST,
        'AI Banner > Close',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.ai-quiz-banner__wrapper {
  @apply px-4 pb-4 md:px-9 relative text-base-0 hidden lg:flex;
  @apply items-center justify-center;
  min-height: 119px;
  transition: all 0.2s ease;
  background-color: #F9FBFF;
  .banner__image {
    @apply w-full;
  }
  .banner__text {
    @apply absolute left-20 leading-3 xl:leading-6 top-2 xl:top-6;
    @media (min-width: 1125px) {
      @apply top-2;
    }
    @media (min-width: 1500px) {
      top: 15%;
    }
    .banner__text--under {
      @apply flex items-center mb-0 mt-0;
      .banner__icon {
        transform: rotate(180deg);
        @apply pr-1;
      }
      @media (min-width: 1175px) {
        @apply mb-2;
      }
      @media (min-width: 1204px) {
        @apply mt-1;
      }
    }
    .banner__button {
      @apply text-xs;
      @media (min-width: 1175px) {
        @apply text-sm;
      }
    }
  }
  .banner__close {
    @apply absolute top-3 right-16 cursor-pointer hover:text-base-20;
  }
}
</style>
